import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Box, Typography, alpha, useTheme } from '@mui/material';
import { LockOutlined } from '@mui/icons-material';
import useTenant from '../../hooks/useTenant';

/**
 * Tenant inativo (contrato encerrado): substitui o app inteiro, com a marca do cliente.
 * Mesmo fundo da Page404, sem animação nem ação — não há pra onde ir.
 */
function AcessoEncerrado() {
  const { t } = useTranslation();
  const theme = useTheme();
  const { branding } = useTenant();
  const primary = branding?.corPrimaria || theme.palette.primary.main;

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        px: 3,
        py: 6,
        textAlign: 'center',
        background: `radial-gradient(120% 90% at 50% 0%, ${alpha(primary, 0.85)} 0%, ${primary} 45%, ${theme.palette.augmentColor({ color: { main: primary } }).dark} 100%)`,
      }}
    >
      <Helmet title={t('Access closed')} />

      {branding?.logoInvertidoUrl && (
        <Box
          component="img"
          src={branding.logoInvertidoUrl}
          alt={branding?.nome ?? ''}
          sx={{ height: { xs: 40, sm: 52 }, objectFit: 'contain', mb: 5 }}
        />
      )}

      <LockOutlined sx={{ fontSize: 56, color: alpha('#fff', 0.9), mb: 2 }} />
      <Typography component="h1" sx={{ color: '#fff', fontWeight: 800, fontSize: { xs: '1.5rem', sm: '2rem' }, mb: 1 }}>
        {t('Access closed')}
      </Typography>
      <Typography sx={{ color: alpha('#fff', 0.85), maxWidth: 460, fontSize: { xs: '0.95rem', sm: '1.05rem' } }}>
        {t('This platform is no longer available. For questions, please contact the organizer.')}
      </Typography>
    </Box>
  );
}

export default AcessoEncerrado;
